import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {TenantDashboardComponent} from './tenant-dashboard.component';
import {ToolbarButton} from '../../models/toolbar-button/toolbar-button';
import { ViewInstanceDetailsComponent } from './view-instance-details/view-instance-details.component';

const routes: Routes = [
  {
    path: '',
    component: TenantDashboardComponent,
    data: {
      activeLink: ToolbarButton.HOME
    },
    title: 'Dashboard',
  },
  {
    path: 'instance/:instanceId/:solutionId/:blueprintId',
    component: ViewInstanceDetailsComponent,
    title: 'Dashboard',
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TenantDashboardRoutingModule {
}
